import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
const PrincipalMessage = () => {
    useEffect(() => {
        document.title = 'Principal Message -  Mary Matha Cmi  Academy';  
    }, []); 
    const [data, setData] = useState([]);
useEffect(() => {
 const fetchData = async () => {
   try {
     const msgdata = await getPrincipalMessage();
    const data = msgdata.filter((item) => item.category === "Principal");
    
     setData(data);
   } catch (error) {
     console.error("Error fetching online registration data:", error);
   }  
 };
 fetchData();
}, []);
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>  
     <li> Principal's Message </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1> Principal's Message  </h1>
         </div>
     </div>
     <div className="row">
     {data.length > 0 && (
       <div className="clearfix">
          <LazyLoad> <img 
           src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0].attachments}`} 
           className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
           alt={data[0].name || 'Image'}
         /></LazyLoad>
         <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
         <p className="name">
           {data[0].name}<span> {data[0].category} </span>
         </p>
       </div>
     )}

     {data.length === 0  && (
       <div className="clearfix">
          <LazyLoad> <img 
           src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/dummy.jpg" 
           className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
           alt=""
         /></LazyLoad>
           
            <p>  Our prestigious School has most successfully entered into 27 th year of excellent educational service striving with sincere dedication to nurture the future of all children entrusted to our care. It is a matter of soulful solace that God continues to shower his plentiful blessing through the powerful intercession of St. Kuriakose Elias Chavara the founder of CMI Congregation. Mother Marty, the heavenly patron of school continues to watch over us protecting us from any eventual calamity. As we march ahead with great success stories in academic and non-academic, I am impelled to share a soul-stirring thought that has been overwhelmingly occupying my mind.  We live in the ultra-modern era o knowledge explosion. All kinds of information and knowledge are available at the click of the mouse and at the tip of our fingers on the touch screen mobiles. With the arrival of latest technologies the role of parents and teachers are imminently tending to be replaced. electronic gadgets such as mobile phones and iPods are apparently trying to shrink social relationship. Social media platforms have become the driving force for each one's existence.</p>
         <p className="name">
         Principal Name   <span>  Principal </span>
         </p>
       </div>
     )}
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default PrincipalMessage
